export default "__VITE_ASSET__18a9b866__"